module.exports = __webpack_public_path__ + "static/img/hzhb_dh.7a27838.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_dh.png
// module id = UaLd
// module chunks = 0